module.exports = __webpack_public_path__ + "static/media/IMG_20150907_235315.e120df36.jpg";